var _rect, _rect2, _rect3, _polygon, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _polygon2, _rect13, _rect14, _rect15, _rect16, _rect17, _polygon3, _polygon4, _polygon5, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _polygon6, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _polygon7, _rect55, _polygon8, _rect56, _rect57, _path, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _polygon9, _polygon10, _rect71, _polygon11, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _polygon12, _rect85, _polygon13, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _polygon14, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _polygon15, _polygon16, _rect101, _rect102, _rect103, _polygon17, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _polygon18, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _polygon19, _rect136, _rect137, _rect138, _rect139;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgB1Inline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 990 720"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 143,
    width: 21,
    height: 43,
    "data-id": "A60"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 76.14,
    y: 143,
    width: 21.86,
    height: 43,
    "data-id": "A61,62"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 187.08,
    width: 21,
    height: 43.92,
    "data-id": "A59"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "76 187 98 187 98 231 76.14 231 76 187",
    "data-id": "A61,62"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 143,
    width: 21,
    height: 43,
    "data-id": "A64"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 149.06,
    y: 143,
    width: 21.94,
    height: 43,
    "data-id": "A66"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 172.01,
    y: 143,
    width: 20.99,
    height: 43,
    "data-id": "A68"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 187,
    width: 21,
    height: 44,
    "data-id": "A63"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 149.06,
    y: 187,
    width: 21.94,
    height: 44,
    "data-id": "A65"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 172.01,
    y: 187,
    width: 20.99,
    height: 44,
    "data-id": "A67"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 204.88,
    y: 143,
    width: 22.12,
    height: 43,
    "data-id": "A69,70"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 204.88,
    y: 187,
    width: 22.12,
    height: 44,
    "data-id": "A69,70"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 238.02,
    y: 143,
    width: 21.98,
    height: 43,
    "data-id": "A72"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "260.94 143 282 143 282 186 261 186 260.94 143",
    "data-id": "A74"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 238.02,
    y: 187,
    width: 21.98,
    height: 44,
    "data-id": "A71"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 260.94,
    y: 187,
    width: 21.06,
    height: 44,
    "data-id": "A73"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 289,
    y: 205,
    width: 21,
    height: 43,
    "data-id": "A140"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 311.03,
    y: 205,
    width: 21.97,
    height: 43,
    "data-id": "A141"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 343.04,
    y: 205,
    width: 20.96,
    height: 43,
    "data-id": "A142"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "373.13 205 395 205 395 248 373 248 373.13 205",
    "data-id": "A143"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "395.93 205 417 205 417 248 396 248 395.93 205",
    "data-id": "A144"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "418.07 205 439 205 439 248 417.92 248 417.92 205 418.07 205",
    "data-id": "A145"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 471,
    y: 203,
    width: 22,
    height: 44,
    "data-id": "A146"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 493.94,
    y: 203,
    width: 21.06,
    height: 44,
    "data-id": "A147"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 521.93,
    y: 203,
    width: 21.07,
    height: 44,
    "data-id": "A148"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 545.11,
    y: 203,
    width: 20.89,
    height: 44,
    "data-id": "A149"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 277,
    width: 21,
    height: 44,
    "data-id": "A57"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 277,
    width: 21,
    height: 44,
    "data-id": "A55"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 321.87,
    width: 21,
    height: 44.12,
    "data-id": "A58"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 321.87,
    width: 21,
    height: 44.12,
    "data-id": "A56"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 366.96,
    width: 21,
    height: 43.04,
    "data-id": "A41,42"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 366.96,
    width: 21,
    height: 43.04,
    "data-id": "A43,44"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 411.06,
    width: 21,
    height: 43.94,
    "data-id": "A41,42"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 411.06,
    width: 21,
    height: 43.94,
    "data-id": "A43,44"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 133,
    y: 407,
    width: 21,
    height: 44,
    "data-id": "A45"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "155 407 176 407 176 451 155 451",
    "data-id": "A46"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 401,
    width: 44,
    height: 21,
    "data-id": "A48"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 423,
    width: 44,
    height: 21.92,
    "data-id": "A47"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 371,
    width: 44,
    height: 21,
    "data-id": "A49"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 348.96,
    width: 44,
    height: 21.18,
    "data-id": "A50"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 319.06,
    width: 44,
    height: 21.94,
    "data-id": "A51"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 297.02,
    width: 44,
    height: 21.03,
    "data-id": "A52"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 277,
    width: 22,
    height: 44,
    "data-id": "A53"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 129.93,
    y: 277,
    width: 30.07,
    height: 44,
    "data-id": "A54"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 284,
    y: 306,
    width: 43,
    height: 21.99,
    "data-id": "A75,76"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 284,
    y: 329.07,
    width: 43,
    height: 20.93,
    "data-id": "A77,78"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 328.93,
    y: 306,
    width: 43.07,
    height: 21.99,
    "data-id": "A75,76"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 328.93,
    y: 329.07,
    width: 43.07,
    height: 20.93,
    "data-id": "A77,78"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 284,
    y: 361.97,
    width: 43,
    height: 21.03,
    "data-id": "A79,80"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 284,
    y: 383.95,
    width: 43,
    height: 21.05,
    "data-id": "A81,82"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 328.78,
    y: 361.97,
    width: 43.22,
    height: 21.03,
    "data-id": "A79,80"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 328.78,
    y: 383.95,
    width: 43.22,
    height: 21.05,
    "data-id": "A81,82"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 284,
    y: 415.9,
    width: 43,
    height: 21.1,
    "data-id": "A83,84"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 328.01,
    y: 415.9,
    width: 43.99,
    height: 21.1,
    "data-id": "A83,84"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 289,
    y: 446,
    width: 22,
    height: 44,
    "data-id": "A85"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 446,
    width: 21,
    height: 44,
    "data-id": "A86"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 341.76,
    y: 446,
    width: 31.24,
    height: 44,
    "data-id": "A87"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 381,
    y: 299,
    width: 22,
    height: 43.1,
    "data-id": "A138,139"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 404.04,
    y: 299,
    width: 20.96,
    height: 43.1,
    "data-id": "A136"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 381,
    y: 342.82,
    width: 22,
    height: 44.2,
    "data-id": "A138,139"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "390 406 411 406 411 450 388.83 450 388.83 406 390 406",
    "data-id": "A88,89"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 389,
    y: 451,
    width: 22,
    height: 43,
    "data-id": "A88,89"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "411.97 451 433 451 433 494 412 494 411.97 451",
    "data-id": "A90,91"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 412.02,
    y: 406,
    width: 20.98,
    height: 44,
    "data-id": "A90,91"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 462,
    y: 451,
    width: 21,
    height: 44,
    "data-id": "A92"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M484.12,451h21.88v44h-21.88v-44Z",
    "data-id": "A93"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 507,
    y: 451,
    width: 21,
    height: 44,
    "data-id": "A94"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 535.11,
    y: 451,
    width: 22.89,
    height: 39,
    "data-id": "A95"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 483,
    y: 416.99,
    width: 43,
    height: 21.01,
    "data-id": "A128,129"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 527.07,
    y: 416.99,
    width: 43.93,
    height: 21.01,
    "data-id": "A128,129"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 528,
    y: 378,
    width: 43,
    height: 21,
    "data-id": "A130"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 528,
    y: 355.04,
    width: 43,
    height: 21.96,
    "data-id": "A131"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 528,
    y: 327,
    width: 43,
    height: 21.21,
    "data-id": "A132"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 528,
    y: 304.06,
    width: 43,
    height: 21.94,
    "data-id": "A133"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 492,
    y: 294,
    width: 21,
    height: 44,
    "data-id": "A134"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 469.77,
    y: 294,
    width: 21.23,
    height: 44,
    "data-id": "A135"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 502,
    width: 21,
    height: 44,
    "data-id": "A39,40"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 546.9,
    width: 21,
    height: 43.1,
    "data-id": "A39,40"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 75.05,
    y: 546.9,
    width: 20.95,
    height: 43.1,
    "data-id": "A37,38"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "74.93 502 96 502 96 546 75.05 546 74.93 502",
    "data-id": "A37,38"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "97.89 502 119 502 119 546 98 546 97.89 502",
    "data-id": "A35,36"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 97.89,
    y: 546.9,
    width: 21.11,
    height: 43.1,
    "data-id": "A35,36"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "131.95 590 131.95 546.9 153 546.9 153 590 132 590",
    "data-id": "A33,34"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 131.95,
    y: 502,
    width: 21.05,
    height: 44,
    "data-id": "A33,34"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 153.95,
    y: 502,
    width: 21.05,
    height: 44,
    "data-id": "A32"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 153.95,
    y: 546.9,
    width: 21.05,
    height: 43.1,
    "data-id": "A31"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 187,
    y: 502,
    width: 22,
    height: 44,
    "data-id": "A29,30"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 502,
    width: 21,
    height: 44,
    "data-id": "A28"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 186.79,
    y: 546.9,
    width: 22.21,
    height: 44.1,
    "data-id": "A29,30"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 546.9,
    width: 21,
    height: 44.1,
    "data-id": "A27"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 545,
    width: 22,
    height: 44,
    "data-id": "A26"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 260.89,
    y: 545,
    width: 21.18,
    height: 44,
    "data-id": "A25"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 288.86,
    y: 545,
    width: 21.14,
    height: 44,
    "data-id": "A24"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 310.93,
    y: 545,
    width: 22.07,
    height: 44,
    "data-id": "A23"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 344,
    y: 545,
    width: 31,
    height: 44,
    "data-id": "A22"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 387.96,
    y: 545,
    width: 21.04,
    height: 44,
    "data-id": "A21"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "410.24 545 432 545 432 589 409.88 589 409.88 545 410.24 545",
    "data-id": "A20"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 432.86,
    y: 545,
    width: 21.14,
    height: 44,
    "data-id": "A19"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "461.93 545 483 545 483 589 462 589 461.93 545",
    "data-id": "A18"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 484.94,
    y: 545,
    width: 21.06,
    height: 44,
    "data-id": "A17"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 506.99,
    y: 545,
    width: 21.01,
    height: 44,
    "data-id": "A16"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 537.46,
    y: 545,
    width: 21.89,
    height: 44,
    "data-id": "A15"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 571.02,
    y: 545,
    width: 20.98,
    height: 44,
    "data-id": "A14"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 593.03,
    y: 545,
    width: 20.97,
    height: 44,
    "data-id": "A13"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 624,
    y: 539,
    width: 21,
    height: 48,
    "data-id": "A12"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 647.08,
    y: 539,
    width: 19.92,
    height: 48,
    "data-id": "A11"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 675,
    y: 535,
    width: 31,
    height: 45,
    "data-id": "A10"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 713,
    y: 537,
    width: 21,
    height: 49,
    "data-id": "A09"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "736.26 537 756 537 756 586 735.9 586 735.9 537 736.26 537",
    "data-id": "A08"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 759.05,
    y: 537,
    width: 19.95,
    height: 49,
    "data-id": "A07"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 811,
    y: 533,
    width: 21,
    height: 44,
    "data-id": "A06"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 832.93,
    y: 533,
    width: 21.07,
    height: 44,
    "data-id": "A05"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 863,
    y: 537,
    width: 20,
    height: 49,
    "data-id": "A04"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 885,
    y: 537,
    width: 20,
    height: 49,
    "data-id": "A03"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 914,
    y: 533,
    width: 21,
    height: 42.89,
    "data-id": "A02"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "936.08 533 958 533 958 576 936 576 936 533 936.08 533",
    "data-id": "A01"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "625 430 644 430 645 430 645 468 624.06 468 624.06 430 625 430",
    "data-id": "A96"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 646.87,
    y: 430,
    width: 20.13,
    height: 38,
    "data-id": "A97"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 675,
    y: 435,
    width: 21,
    height: 43,
    "data-id": "A98"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 619,
    y: 406,
    width: 43,
    height: 21.67,
    "data-id": "A126"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "663.17 406 706 406 706 427.67 662.94 427.67 662.94 406 663.17 406",
    "data-id": "A127"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 619,
    y: 377.94,
    width: 43,
    height: 21.06,
    "data-id": "A124"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 662.94,
    y: 377.94,
    width: 43.06,
    height: 21.06,
    "data-id": "A125"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 619,
    y: 355.01,
    width: 43,
    height: 21.99,
    "data-id": "A122"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 662.94,
    y: 355.01,
    width: 43.06,
    height: 21.99,
    "data-id": "A123"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 619,
    y: 326.73,
    width: 43,
    height: 21.43,
    "data-id": "A121"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 619,
    y: 304,
    width: 43,
    height: 21.67,
    "data-id": "A120"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 670,
    y: 303,
    width: 21,
    height: 44,
    "data-id": "A119"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 692.05,
    y: 303,
    width: 20.95,
    height: 44,
    "data-id": "A118"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 729.01,
    y: 303,
    width: 20.99,
    height: 44,
    "data-id": "A117"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 751.11,
    y: 303,
    width: 20.89,
    height: 44,
    "data-id": "A116"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 802,
    y: 300,
    width: 21,
    height: 44.11,
    "data-id": "A114"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 824.78,
    y: 300,
    width: 21.22,
    height: 44,
    "data-id": "A112"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 847,
    y: 300,
    width: 21,
    height: 44,
    "data-id": "A111"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 802,
    y: 345.04,
    width: 21,
    height: 42.96,
    "data-id": "A115"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 824.13,
    y: 345.04,
    width: 21.87,
    height: 42.96,
    "data-id": "A113"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 877.08,
    y: 300,
    width: 20.92,
    height: 44,
    "data-id": "A109"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 877.08,
    y: 345.04,
    width: 20.92,
    height: 43.96,
    "data-id": "A110"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 833,
    y: 390,
    width: 20.97,
    height: 43.98,
    "data-id": "A104"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 811,
    y: 435,
    width: 21,
    height: 43,
    "data-id": "A101"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 721.74,
    y: 435,
    width: 21.26,
    height: 44,
    "data-id": "A99"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 861.84,
    y: 390,
    width: 21.16,
    height: 43.98,
    "data-id": "A106"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 884.05,
    y: 390,
    width: 20.95,
    height: 43.98,
    "data-id": "A108"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "861.84 435 883 435 883 478 861.84 478",
    "data-id": "A105"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 884.05,
    y: 435,
    width: 20.95,
    height: 43,
    "data-id": "A107"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 744,
    y: 435,
    width: 21,
    height: 44,
    "data-id": "A100"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 833,
    y: 435,
    width: 20.97,
    height: 43,
    "data-id": "A103"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 624,
    y: 203,
    width: 21,
    height: 44,
    "data-id": "A150"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 646,
    y: 203,
    width: 22,
    height: 44,
    "data-id": "A151"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 675,
    y: 203,
    width: 21,
    height: 44,
    "data-id": "A152"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 697.82,
    y: 203,
    width: 21.18,
    height: 44,
    "data-id": "A153"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 727.95,
    y: 203,
    width: 21.05,
    height: 44,
    "data-id": "A154"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    x: 750.04,
    y: 203,
    width: 20.97,
    height: 44,
    "data-id": "A155"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 772.01,
    y: 203,
    width: 20.99,
    height: 44,
    "data-id": "A156"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "801.96 203 823 203 823 247 802 247 801.96 203",
    "data-id": "A157"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 824.19,
    y: 203,
    width: 21.81,
    height: 44,
    "data-id": "A158"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 847.04,
    y: 203,
    width: 20.96,
    height: 44,
    "data-id": "A159"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 914,
    y: 205,
    width: 21,
    height: 45,
    "data-id": "A161"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    x: 936,
    y: 205,
    width: 22,
    height: 45,
    "data-id": "A162"
  })));
}
export default __webpack_public_path__ + "static/b-1.inline.b2a13e9b.svg";
export { SvgB1Inline as ReactComponent };